import * as React from "react";
import type { SVGProps } from "react";
const SvgReceiptDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    viewBox="0 0 13 13" {...props}
  >
    <path
      fill="#258695"
      fillRule="evenodd"
      d="M2.343 0h8.603c.617 0 1.12.507 1.12 1.128V12.13c0 .295-.24.536-.533.536H3.36a.537.537 0 0 1-.533-.536V1.128A1.13 1.13 0 0 0 2.295.17a.09.09 0 0 1-.04-.104A.09.09 0 0 1 2.344 0M0 1.37C0 .632.6.26 1.182.257c.547-.002 1.078.325 1.078.987v5.341a.23.23 0 0 1-.228.23h-.965A1.073 1.073 0 0 1 0 5.74z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReceiptDark;
